import { render } from "./DetailProduct.vue?vue&type=template&id=f608f66c"
import script from "./DetailProduct.vue?vue&type=script&lang=js"
export * from "./DetailProduct.vue?vue&type=script&lang=js"

import "./DetailProduct.vue?vue&type=style&index=0&id=f608f66c&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__